export const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve) => {
    const reader = new FileReader()

    reader.readAsDataURL(file)

    reader.onload = () => {
      const base64 = reader.result?.toString().replace('data:', '').replace(/^.+,/, '')
      if (base64 !== undefined) {
        resolve(base64)
      }
    }
  })
}

export const base64ToBlob = async (base64: string, type = 'application/octet-stream') => {
  const response = await fetch(`data:${type};base64,${base64}`)
  return response.blob()
}
